export function searchPage() {
    const searchForm = document.getElementById("page-search");

    if (searchForm) {
        const API_URL = searchForm.action;
        const belowSearchContainer = document.querySelector(".pul-page-search .below-search-container");
        const searchResultList = document.querySelector(".pul-page-search .pul-page-search__results");
        const submitButton = searchForm.querySelector("button");
        const inputField = searchForm.querySelector("input");

        const searchTermEl = document.querySelector(".pul-page-search .search-term");
        const resultNumberEl = document.querySelector(".pul-page-search .result-number");
        const errorEl = document.querySelector(".pul-page-search .error-msg");

        inputField.addEventListener("input", () => {
            if (inputField.value.trim() === "" || inputField.value.trim().length < 2) {
                submitButton.setAttribute("disabled", "");
                return;
            } else {
                submitButton.removeAttribute("disabled");
            }
        });

        searchForm.addEventListener("submit", function (event) {
            event.preventDefault();

            searchResultList.innerHTML = "";
            errorEl.removeAttribute("style");
            submitButton.classList.add("loading");

            fetchSearchResults(searchForm);
        });

        async function fetchSearchResults(searchForm) {
            const formData = new FormData(searchForm);
            const searchTerm = Object.fromEntries(formData).SearchTerm;

            try {
                const response = await fetch(API_URL, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    },
                    body: new URLSearchParams(new FormData(searchForm)).toString(),
                });

                const data = await response.json();

                submitButton.classList.remove("loading");

                if (data.length > 0) {
                    for (const searchResult of data) {
                        const resultItem = document.createElement("div");
                        resultItem.classList.add("pul-page-search__results-item");

                        resultItem.innerHTML = `
                            <div class="text-highlight">${searchResult.Title}</div>
                            <p>${searchResult.Description}</p>
                            <a href="${searchResult.Link}" class="text-highlight">${searchResult.LinkText}
                                <svg width="25" height="18" viewBox="0 0 25 18" aria-hidden="true">
                                    <use href="/ResourcePackages/pfeiferlangen/assets/img/_icn/icn-search-arrow.svg#icn"></use>
                                </svg>
                            </a>
                        `;

                        searchResultList.appendChild(resultItem);
                    }

                    searchTermEl.textContent = searchTerm;
                    resultNumberEl.textContent = data.length;

                    belowSearchContainer.classList.add("has-results");
                } else {
                    belowSearchContainer.classList.remove("has-results");
                    searchResultList.innerHTML = "";
                    searchTermEl.textContent = "";
                    resultNumberEl.textContent = "";
                    errorEl.style.display = "block";
                }
            } catch (error) {
                console.error("Error fetching search results:", error);
                submitButton.classList.remove("loading");
            }
        }
    }
}